import * as React from "react";
const SvgFiRrCloudRain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-rain_svg__a)">
      <path
        fill="#062147"
        d="M16 24a2.98 2.98 0 0 1-2.121-.879c-1.942-1.813-.137-4.486 1-5.639a1.557 1.557 0 0 1 2.208-.041C17.56 17.953 19 19.613 19 21a3.015 3.015 0 0 1-3 3m0-4.759c-.73 1.054-1.39 1.669-.707 2.466A1.01 1.01 0 0 0 17 21a4.5 4.5 0 0 0-1-1.759M8 24a2.98 2.98 0 0 1-2.122-.879c-1.941-1.812-.136-4.486 1-5.639a1.573 1.573 0 0 1 2.208-.04c1.17 1.169 2.986 3.847 1.037 5.679A2.98 2.98 0 0 1 8 24m0-4.759A4.6 4.6 0 0 0 7 21a1.01 1.01 0 0 0 1.707.707c.693-.792 0-1.461-.707-2.466m-5 0a1 1 0 0 1-.555-.169A5.536 5.536 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.889A7.95 7.95 0 0 1 8.5.137a8.056 8.056 0 0 1 8.734 4.44 1.04 1.04 0 0 0 .742.569c5.825 1.035 8.092 8.769 3.719 12.766a1 1 0 1 1-1.384-1.444 5.538 5.538 0 0 0-2.726-9.362 3.01 3.01 0 0 1-2.158-1.672A6 6 0 0 0 4.11 9.148a3 3 0 0 1-.964 2.762 3.523 3.523 0 0 0 .41 5.5A1 1 0 0 1 3 19.242zM12 17a2.98 2.98 0 0 1-2.121-.879c-1.942-1.812-.137-4.486 1-5.639a1.573 1.573 0 0 1 2.209-.04C13.56 10.953 15 12.613 15 14a3.014 3.014 0 0 1-3 3m0-4.759c-.732 1.054-1.39 1.669-.709 2.466A1.01 1.01 0 0 0 13 14a4.5 4.5 0 0 0-1-1.759"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-rain_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudRain;
